import React, { useLayoutEffect, useRef } from 'react';
import styles from './Style.module.css';
import { preventVerificationOverscroll } from '../../Utils/preventVerificationOverscroll';

export const VerificationLayout = ({ children, footer, className = '', scrollContainerRef }) => {
  const frameRef = useRef(null);

  useLayoutEffect(() => {
    const root = document.documentElement;
    const viewport = window.visualViewport;
    const update = () => {
      const frame = frameRef.current;
      if (!frame) return;
      // Let native pinch zoom work normally instead of resizing its contents.
      if (viewport && Math.abs(viewport.scale - 1) >= 0.01) return;
      frame.style.setProperty('--verification-height', `${viewport?.height ?? window.innerHeight}px`);
      frame.style.setProperty('--verification-top', `${viewport?.offsetTop ?? 0}px`);
    };

    root.classList.add('verification-open');
    const releaseOverscroll = preventVerificationOverscroll();
    update();
    viewport?.addEventListener('resize', update);
    viewport?.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => {
      releaseOverscroll();
      root.classList.remove('verification-open');
      viewport?.removeEventListener('resize', update);
      viewport?.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return (
    <div ref={frameRef} className={`${className} ${styles.frame}`}>
      <div ref={scrollContainerRef} className={styles.content}>{children}</div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};
